import { render, staticRenderFns } from "./AiDashboard.vue?vue&type=template&id=e8f4b2c6&scoped=true"
import script from "./AiDashboard.vue?vue&type=script&lang=js"
export * from "./AiDashboard.vue?vue&type=script&lang=js"
import style0 from "./AiDashboard.vue?vue&type=style&index=0&id=e8f4b2c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f4b2c6",
  null
  
)

export default component.exports